import React, { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const TermsAndConditions = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const isModal = location?.state?.isModal === true;

  useEffect(() => {
    if (isModal) {
      document.body.style.overflow = 'hidden';
      document.body.classList.add('modal-open');
    }
    return () => {
      document.body.style.overflow = '';
      document.body.classList.remove('modal-open');
    };
  }, [isModal]);

  const pageStyle = {
    maxWidth: "800px",
    margin: "20px auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
    color: "#dfbd69",
    borderRadius: "10px",
    backgroundColor: "transparent",
  };
  const headingStyle = {
    color: "#dfbd69",
    textAlign: "center",
    marginBottom: "20px",
  };

  const sectionHeadingStyle = {
    color: "#dfbd69",
    fontSize: "1.2rem",
    margin: "15px 0",
  };

  const modalOverlay = {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 11000
  };
  const modalBox = {
    maxWidth: '900px', width: '95vw', maxHeight: '80vh', overflowY: 'auto', background: 'transparent', padding: 20, borderRadius: 12
  };

  const renderTermsContent = () => (
    <div style={pageStyle}>
      <h1 style={headingStyle}>{t("termsPage.title")}</h1>
      <p>{t("termsPage.intro1")}</p>
      <p>{t("termsPage.intro2")}</p>
      <ol>
        <li>
          <h2 style={sectionHeadingStyle}>{t("termsPage.natureTitle")}</h2>
          <p>{t("termsPage.natureText")}</p>
        </li>
        <li>
          <h2 style={sectionHeadingStyle}>{t("termsPage.nonRelianceTitle")}</h2>
          <ul>
            <li>{t("termsPage.nonRelianceList1")}</li>
            <li>{t("termsPage.nonRelianceList2")}</li>
            <li>{t("termsPage.nonRelianceList3")}</li>
            <li>{t("termsPage.nonRelianceList4")}</li>
          </ul>
          <h2 style={sectionHeadingStyle}>{t("termsPage.disclaimerTitle")}</h2>
          <p>{t("termsPage.disclaimerText")}</p>
        </li>
        <li>
          <h2 style={sectionHeadingStyle}>{t("termsPage.riskTitle")}</h2>
          <ul>
            <li>{t("termsPage.riskList1")}</li>
            <li>{t("termsPage.riskList2")}</li>
            <li>{t("termsPage.riskList3")}</li>
            <li>{t("termsPage.riskList4")}</li>
          </ul>
        </li>
        <li>
          <h2 style={sectionHeadingStyle}>{t("termsPage.privacyTitle")}</h2>
          <p>{t("termsPage.privacyText1")}</p>
          <ul>
            <li>
              <strong>{t("termsPage.privacyAccuracyLabel")}</strong> {t("termsPage.privacyAccuracyText")}
            </li>
            <li>
              <strong>{t("termsPage.privacyPurposeLabel")}</strong> {t("termsPage.privacyPurposeText")}
            </li>
          </ul>
          <p>
            {t("termsPage.privacyContact")}
            <a href="mailto:contact@xianhefairy.com">contact@xianhefairy.com</a>
            {t("termsPage.privacyContactSuffix")}
          </p>
          <p>
            {t("termsPage.privacyContactProduct")}
          </p>
        </li>
        <li>
          <h2 style={sectionHeadingStyle}>{t("termsPage.marketingTitle")}</h2>
          <ul>
            <li>{t("termsPage.marketingList1")}</li>
            <li>{t("termsPage.marketingList2")}</li>
            <li>{t("termsPage.marketingList3")}</li>
          </ul>
        </li>
        <li>
          <h2 style={sectionHeadingStyle}>{t("termsPage.ageTitle")}</h2>
          <ul>
            <li>{t("termsPage.ageList1")}</li>
            <li>{t("termsPage.ageList2")}</li>
          </ul>
        </li>
        <li>
          <h2 style={sectionHeadingStyle}>{t("termsPage.ipTitle")}</h2>
          <p>{t("termsPage.ipText1")}</p>
          <p>{t("termsPage.ipText2")}</p>
        </li>
        <li>
          <h2 style={sectionHeadingStyle}>{t("termsPage.accountsTitle")}</h2>
          <p>{t("termsPage.accountsText1")}</p>
          <p>{t("termsPage.accountsText2")}</p>
          <p>{t("termsPage.accountsText3")}</p>
          <h2 style={sectionHeadingStyle}>{t("termsPage.deletionTitle")}</h2>
          <p>
            {t("termsPage.deletionText1")}
            <a href="https://xianhefairy.com/contact">{t("termsPage.deletionLinkText")}</a>
            {t("termsPage.deletionText2")}
          </p>
        </li>
        <li>
          <h2 style={sectionHeadingStyle}>{t("termsPage.refundTitle")}</h2>
          <p>{t("termsPage.refundText1")}</p>
          <p>{t("termsPage.refundText2")}</p>
          <p>
            <strong>{t("termsPage.refundChargebackLabel")}</strong> {t("termsPage.refundChargebackText")}
          </p>
          <p>
            <strong>{t("termsPage.refundCheckboxLabel")}</strong> {t("termsPage.refundCheckboxText")}
          </p>
          <h2 style={sectionHeadingStyle}>{t("termsPage.subscriptionTitle")}</h2>
          <p>
            <strong>{t("termsPage.subscriptionAccessLabel")}</strong> {t("termsPage.subscriptionAccessText")}
          </p>
        </li>
        <li>
          <h2 style={sectionHeadingStyle}>{t("termsPage.gstTitle")}</h2>
          <p>{t("termsPage.gstText")}</p>
        </li>
        <li>
          <h2 style={sectionHeadingStyle}>{t("termsPage.governingTitle")}</h2>
          <p>{t("termsPage.governingText")}</p>
        </li>
        <li>
          <h2 style={sectionHeadingStyle}>{t("termsPage.indemnityTitle")}</h2>
          <p>{t("termsPage.indemnityText")}</p>
          <ul>
            <li>{t("termsPage.indemnityList1")}</li>
            <li>{t("termsPage.indemnityList2")}</li>
            <li>{t("termsPage.indemnityList3")}</li>
            <li>{t("termsPage.indemnityList4")}</li>
            <li>{t("termsPage.indemnityList5")}</li>
          </ul>
        </li>
        <li>
          <h2 style={sectionHeadingStyle}>{t("termsPage.liabilityTitle")}</h2>
          <p>{t("termsPage.liabilityText")}</p>
        </li>
        <li>
          <h2 style={sectionHeadingStyle}>{t("termsPage.entireTitle")}</h2>
          <p>{t("termsPage.entireText")}</p>
        </li>
      </ol>
    </div>
  );

  if (isModal) {
    return (
      <div style={modalOverlay} onClick={() => navigate(-1)}>
        <div style={modalBox} onClick={(e) => e.stopPropagation()}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <h1 style={headingStyle}>{t("termsPage.title")}</h1>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => navigate('/terms-conditions')} style={{ background: 'transparent', border: '1px solid #DFBD69', color: '#DFBD69', padding: '6px 10px', borderRadius: 8 }}>{t("termsPage.openFullPage")}</button>
              <button onClick={() => navigate(-1)} style={{ background: '#DFBD69', border: 'none', color: '#151517', padding: '6px 10px', borderRadius: 8 }}>{t("termsPage.close")}</button>
            </div>
          </div>
          <div style={{ backgroundColor: 'rgba(10,3,30,0.95)', borderRadius: 8, padding: 18 }}>
            {renderTermsContent()}
          </div>
        </div>
      </div>
    );
  }

  return renderTermsContent();
};

export default TermsAndConditions;
